import { Component, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { sla, kpiRelease, quater, year, kpi, slaIssueList, actionPlan } from './../../../models/slakpi';
import { division } from './../../../models/admin';
import { UtilityService } from './../../../services/utility.service';
import { SLAKPIApiService } from './../../../services/slakpi.service';
import { AdminApiService } from './../../../services/admin.service';
import { UserService } from './../../../services/user.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { KPIInfoComponent } from './../../../component/slakpi/kpi-info/kpi-info.component';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  OnEventArgs,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToasterService } from '../../../toaster.service';
import { EChartsOption } from 'echarts';
import { uniqBy } from 'lodash';
@Component({
  selector: 'app-slaissue-action.component',
  templateUrl: './slaissue-action.component.html',
  styleUrls: ['./slaissue-action.component.css']

})
export class SLAIssueActionComponent implements OnInit {
  //Global Variables
  public sli_data: any;
  public slaIssuelist_data: any;
  public issueComment_data_hostory: any = [];
  public txtIssueInfo: string = '';
  public yearData: any;
  public quaterData: any;
  public division_data: any;
  public frequency_data: any;
  public resettype_data: any;
  public slaUno?: number;
  public yearUno?: number;
  public quarterUno?: number;
  public divisionUno?: number;
  public frequencyUno?: number;
  public historyStartIndex: number = 1;
  public historyMaxCount: number = 100;
  historydisableMore: boolean = true;
  public objkpiRelease: kpiRelease;
  public kpinameSelected: string = '';
  public pageSettings_Justfication: Object;
  public toolbar_Justfication: Object;
  public isback: boolean = false;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  public loading: boolean = true;
  angularGrid: AngularGridInstance;
  dataset: any;
  gridOptionsHistory: GridOption;
  columnCommentDefinitions: Column[];
  cmtsGrid: AngularGridInstance;
  datasetComments: any;
  issueGrid: AngularGridInstance;
  datasetIssues: any;
  columnIssueDefinitions: Column[];
  modalRef: BsModalRef;
  //Syncfusion Control Values

  @ViewChild('IssueDialog', { static: false }) IssueDialog: TemplateRef<any>;
  @ViewChild('IssueCommentDialog', { static: false }) IssueCommentDialog: TemplateRef<any>;
  public filterSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public formatoptions: Object;

  public issuetype_data: any;
  public issueComment: string = '';
  public isResetTypeErr: boolean = false;
  public isCommentErr: boolean = false;
  public resettypeCode: number = 0;
  public objkpiIssueUpdate: number;
  public kpiTrnIssueNo: number;
  public kpiTrnUno: number;
  //for Users Default Value
  user: any = {};
  login_UserID: string; // number
  currentYear?: number;
  currentHalf?: number;
  currentQuarter?: number;
  currentMonth?: number;
  isToggle: boolean = false;
  issueStatusupdate: boolean = true;
  //for Users Permission
  public permision_add: boolean = false;
  public permision_edit: boolean = false;
  public permision_delete: boolean = false;
  public permision_resolve: boolean = false;
  public permision_issueUpdate: boolean = false;

  isAdmin: boolean = false;
  public position_comment: object = { X: 200, Y: 230 };
  public position_issuestatus: object = { X: 450, Y: 230 };

  public Qyearsla: number = 0;
  public Qquatersla: number = 0;
  public Qdivisionsla: number = 0;

  //for KPI All Hisory Dialog

  public kpiUnoSelected: number = 0;
  //public kpinameSelected: string = '';
  @ViewChild('KPIAllHistoryDialog', { static: false }) KPIAllHistoryDialog: TemplateRef<any>;
  public position_history: object = { X: 70, Y: 90 };
  //public wrapSettings: TextWrapSettingsModel;
  public context: any;
  searchText: string;
  dataSearch: any[];
  noDataImg: any;
  tenantUno: any;
  isDigitalDewa: boolean = false;
  selectedJustification: string;
  chartOption05: EChartsOption;
  chartOption06: EChartsOption;
  chartOption07: EChartsOption;
  issueArraised: any;
  wellPerformed: any;
  pendingIssues: any;
  inProgressIssues: any;
  ResolvedIssues: any;
  underPerforming: any;
  issueReported: any;
  issueResolved: any;
  devisionCode: any;
  Piedataset: any;
  Actiondata: any;
  @ViewChild('mapActionDialog', { static: false }) mapActiontemplate: TemplateRef<any>;
  actionKpiUno: any;
  objActionPlan: any = new actionPlan();
  actionPlanID: any;
  isActionPlan: boolean = false;
  ResolutionString: any;
  isInternalAudit: boolean = false;

  constructor(public restApi: SLAKPIApiService, private _activatedRoute: ActivatedRoute, private toaster: ToasterService, public adminService: AdminApiService, private userService: UserService, private modalService: BsModalService,
    public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private kpiAllHistoryComponent: KPIInfoComponent) {
    this._activatedRoute.queryParams.subscribe((params: Params) => {
      
      this.Qyearsla = Number(params['yearsla']);
      this.Qquatersla = Number(params['quatersla']);
      this.Qdivisionsla = Number(params['divisionsla']);
      if (this.Qyearsla > 0) this.isback = true;
    });
    

    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'SLA Admin') ? true : false;
    this.permision_issueUpdate = (this.user.role == 'Administrator' || this.user.role == 'SLA Admin' || this.user.role == 'SLA Coordinator') ? true : false

    this.isInternalAudit = (this.user.role == 'Internal Audit') ? true : false;
    if (!this.isAdmin) {
      this.CheckUserPermission();
    }
    else {
      this.permision_add = true;
      this.permision_edit = true;
      this.permision_delete = true;
      this.permision_resolve = true;

    }

    //this.wrapSettings = { wrapMode: 'Content' };
  }
  ngOnInit() {
   
    this.userService.CheckLogin();
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.currentYear = this.user.currentYear;
    this.currentHalf = this.user.currentHalf;
    this.currentQuarter = this.user.currentQuarter;
    this.currentMonth = this.user.currentMonth;
    this.yearUno = this.currentYear;
    this.quarterUno = this.currentQuarter;


    if (localStorage.getItem('strFilter')) {
      let strFilter = JSON.parse(localStorage.getItem('strFilter'));
      if (strFilter.yearUno != undefined) {
        this.yearUno = Number(strFilter.yearUno);
      }
      if (strFilter.quarterUno != undefined) {
        this.quarterUno = Number(strFilter.quarterUno);
      }

    }

    this.isDigitalDewa = (this.user.tenantDigitalUser == 'true') ? true : false;
    this.objkpiRelease = new kpiRelease();

    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,
      enableCheckboxSelector: false,

      multiSelect: false,
      rowSelectionOptions: {
        // True (Single Selection), False (Multiple Selections)
        selectActiveRow: true,
      },

    };

    this.gridOptionsHistory = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,

      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 100
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'myTabContent',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };

    this.loadFilterValues();
    this.loadFrequency();
    this.loadIssueType();
    this.loadActionPlan();
    this.toolbar = ['Search', 'ExcelExport'];

    this.pageSettings = { pageSize: 20, pageSizes: true };
    this.filterSettings = { type: 'Excel' };
    this.formatoptions = { type: 'date', format: 'dd/MM/yyyy' };
    this.toolbar_Justfication = ['Search'];
    this.pageSettings_Justfication = { pageSize: 5, pageSizes: true };
    //this.loadDashboard(2)
    // setTimeout(() => { this.ResetDialog.hide(); }, 100);

  }
  //To Validate Current User - Page Level Permission
  CheckUserPermission() {

    let userPermissionData = this.userService.getUserRights("SLA Issue List");
    if (this.user.role == 'SLA Admin' || this.user.role == 'SLA Coordinator') {
      this.permision_resolve = true;

    }
    else if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
      if (userPermissionData[0].showPage == 1) {
        this.permision_add = (userPermissionData[0].showAdd == 1) ? true : false;
        this.permision_edit = (userPermissionData[0].showEdit == 1) ? true : false;
        this.permision_delete = (userPermissionData[0].showDelete == 1) ? true : false;
        
        //User rights

        let userPermissionDataRelease = this.userService.getUserRights("Resolve Issue");
        if (userPermissionDataRelease != null && userPermissionDataRelease != undefined && userPermissionDataRelease.length > 0) {
          if (userPermissionDataRelease[0].showPage == 1) {
            this.permision_resolve = true;
          }
          else
            this.permision_resolve = false;
        }

        if (this.user.role == 'SLA Admin' || this.user.role == 'SLA Coordinator')
          this.permision_resolve = true;

      }
      else {
        this.router.navigateByUrl('/access-denied');
      }
    }
    else {
      this.router.navigateByUrl('/access-denied');
    }
  }
  viewKPIHistoryAll(kpiUno: any, kpiNameEn: any) {
    this.kpiUnoSelected = kpiUno;
    this.kpinameSelected = kpiNameEn;
    this.kpiAllHistoryComponent.viewKPI(kpiUno);

    this.modalRef = this.modalService.show(
      this.KPIAllHistoryDialog,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }

  //Load Frequency Values
  loadFilterValues() {
    this.spinner.show();
    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.restApi.getKPITranFilterValues(inpValue)
      .subscribe(data => {
        
        let objdata: any = data;
        this.sli_data = objdata.list_SLAMaster;
        this.division_data = objdata.list_DivisionMaster;
        this.quaterData = objdata.list_QuarterMaster;
        this.yearData = objdata.list_YearMaster;

        setTimeout(() => {
          if (localStorage.getItem('strFilter')) {
            let strFilter = JSON.parse(localStorage.getItem('strFilter'));
            if (strFilter.quarterUno != undefined) {
              this.quarterUno = Number(strFilter.quarterUno);
            }
            if (strFilter.yearUno != undefined) {
              this.yearUno = Number(strFilter.yearUno);
            }
            if (strFilter.frequencyUno != undefined) {
              this.frequencyUno = Number(strFilter.frequencyUno);
            }
            if (strFilter.divisionUno != undefined) {
              this.divisionUno = Number(strFilter.divisionUno);
            }
            if (strFilter.slaUno !=undefined) {
              this.slaUno = Number(strFilter.slaUno);
            }
            this.loadSlaIssueList(2); //by filter
            localStorage.removeItem('strFilter')
          }
          else {
            
            this.yearUno = (this.Qyearsla > 0) ? this.Qyearsla : Number(this.yearUno);
            this.quarterUno = (this.Qquatersla > 0) ? this.Qquatersla : Number(this.quarterUno);
            if (this.Qdivisionsla > 0) {
              this.divisionUno = Number(this.Qdivisionsla);
            }
            this.loadSlaIssueList(2); //by filter
          }
          
          //this.loadDashboard(2);

        }, 30);

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }

  // Get sla list
  loadSLA() {
    this.spinner.show();
    let inpValue = new sla();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;

    this.restApi.getSLAs(inpValue)
      .subscribe(data => {
        
        this.sli_data = data;

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  // Get Year / Quater
  loadYear() {

    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    
    this.restApi.getYearMaster(inpValue)
      .subscribe(data => {
        
        this.yearData = data;

        setTimeout(() => {
          this.yearUno = (this.Qyearsla > 0) ? this.Qyearsla : Number(this.yearUno);
        }, 10);

      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  loadQuater() {

    let inpValue = new quater();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    
    this.restApi.getQuaterMaster(inpValue)
      .subscribe(data => {
        
        this.quaterData = data;
        setTimeout(() => {
          
          //this.quarterUno = (this.Qquatersla > 0) ? this.Qquatersla : Number(this.quarterUno);
          this.loadSlaIssueList(2); //by filter
          //this.loadDashboard(2);
        }, 10);


      },
        (error) => {
          //Called when error
          this.loadSlaIssueList(2); //by filter
          //this.loadDashboard(2);
        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }

  loadDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {
        
        this.division_data = data;

        if (this.Qdivisionsla > 0)
          setTimeout(() => {
            this.divisionUno = Number(this.Qdivisionsla);
          }, 10);

      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }


  loadFrequency() {
    if (this.isDigitalDewa == false) {
      this.frequency_data = [];
      this.frequency_data = [
        { frequencyCode: 1, frequencyName: 'Yearly' },
        { frequencyCode: 2, frequencyName: 'Semi-annually' },
        { frequencyCode: 3, frequencyName: 'Quarterly' }
        //{ frequencyCode: 4, frequencyName: 'Monthly' }
      ];
    }

    if (this.isDigitalDewa == true || this.tenantUno == 5) {
      this.frequency_data = [];
      this.frequency_data = [
        { frequencyCode: 1, frequencyName: 'Yearly' },
        { frequencyCode: 2, frequencyName: 'Semi-annually' },
        { frequencyCode: 3, frequencyName: 'Quarterly' },
        { frequencyCode: 4, frequencyName: 'Monthly' }
      ];
    }
  }
  loadIssueType() {
    this.issuetype_data = [
      { issuetypeCode: 1, issuetypeName: 'Pending' },
      { issuetypeCode: 2, issuetypeName: 'In Progress' },
      { issuetypeCode: 3, issuetypeName: 'Resolved' },
      //{ issuetypeCode: 4, issuetypeName: 'Closed' },
      //{ issuetypeCode: 5, issuetypeName: 'Cancelled' }
    ];
  }
  onchangeIssueType(e) {
    
    this.resettypeCode = (e && e.length > 0 && e[0].value != 'All') ? e[0].value : '';
    if (this.resettypeCode == 0) {
      this.isResetTypeErr = true;
    }
    else
      this.isResetTypeErr = false;
    // this.onSelectedTab();
  }
  showIssueDialog(data: any, isseDesc: any, type: any) {

    this.modalRef = this.modalService.show(
      this.IssueDialog,
      Object.assign({}, {
        class: 'gray modal-medium',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
    this.txtIssueInfo = isseDesc;
    
    this.kpiTrnIssueNo = data.kpiTrnIssueUno;
    this.kpiTrnUno = data.kpiTrnUno;
    this.kpinameSelected = data.kpiName;
    this.isCommentErr = false;
   // this.issueComment = '';
    this.issueComment = isseDesc;
    if (type == 'updatestatus')
      this.issueStatusupdate = true;
    else
      this.issueStatusupdate = false;
  }
  showIssueCommentDialog(data: any) {

    this.modalRef = this.modalService.show(
      this.IssueCommentDialog,
      Object.assign({}, {
        class: 'gray modal-xl',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
    //this.issueComment_data = [];
    this.kpinameSelected = data.kpiName;
    this.selectedJustification = data.issueDescription;
    this.loadIssueCommentHistory(data.kpiTrnIssueUno, true);
  }
  //Get KPI History
  loadIssueCommentHistory(kpiTrnIssueUno: number, isStart) {
    this.spinner.show();
    let inpValue = new slaIssueList();
    inpValue.kpiTrnIssueUno = kpiTrnIssueUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;;
    this.historyStartIndex = (this.historyStartIndex == undefined || this.historyStartIndex < 1 || isStart) ? 1 : this.historyStartIndex;
    inpValue.startIndex = this.historyStartIndex;
    inpValue.maxCount = this.historyMaxCount;

    this.restApi.getkpiIssueComment(inpValue)
      .subscribe(data => {
        
        let objData: any = data;

        if (this.historyStartIndex == 1) {
          this.issueComment_data_hostory = [];
          this.issueComment_data_hostory = objData;
        }
        else {
          for (var i = 0; i < objData.length; i++) {
            this.issueComment_data_hostory.push(objData[i]);
          }
        }

        const mockDataset = [];
        for (let i = 0; i < this.issueComment_data_hostory.length; i++) {
          mockDataset[i] = {
            id: i + 1,
            action: this.issueComment_data_hostory[i].action,
            postedBy: this.issueComment_data_hostory[i].postedBy,
            postedDate: this.issueComment_data_hostory[i].postedDate,
            comment: this.issueComment_data_hostory[i].comment,
          };
        }
        this.datasetComments = mockDataset;
        this.setCommentDefn();
        //if the result set is lessthen 10 then disable the load more icon
        this.historydisableMore = (objData.length >= 100) ? false : true;
        if (objData.length > 0) {
          //this.ifcountgreaterthanzero = true;
          this.historyStartIndex = this.historyStartIndex + 1;
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }


  AddKPIIssueFormSubmit() {
    
    if (this.resettypeCode == 0) {
      this.isResetTypeErr = true;
      return false;
    }
    else
      this.isResetTypeErr = false;

    if (this.issueComment == '') {
      //Swal.fire('Error', 'Please enter comment', 'error')
      this.isCommentErr = true;
      return false;
    }

    if (this.objkpiIssueUpdate <= 0) {
      //Swal.fire('Error', 'KPI update action is not selected ', 'warning');
      this.isResetTypeErr = true;
      return false;
    }
    else {

      Swal.fire({
        title: '',
        text: 'Please confirm to update',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.value) {
          this.modalRef.hide();
          this.onSubmitIssue();
          this.isResetTypeErr = false;
          this.isCommentErr = false;
          return;
        } else if (result.dismiss === Swal.DismissReason.cancel) {

          return;
        }
      })
    }
    return true;

  }

  AddKPIIssueDescriptionSubmit() {
    

    if (this.issueComment == '') {
      //Swal.fire('Error', 'Please enter comment', 'error')
      this.isCommentErr = true;
      return false;
    }


    Swal.fire({
      title: '',
      text: 'Please confirm to update',
      type: 'info',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        this.modalRef.hide();
        this.onSubmitIssueDesc();
        this.issueComment = '';
        this.isCommentErr = false;
        return;
      } else if (result.dismiss === Swal.DismissReason.cancel) {

        return;
      }
    })

    return true;

  }

  onSubmitIssue() {


    let objKPIView = new slaIssueList();
    objKPIView.kpiUno = 0;
    objKPIView.kpiTrnUno=this.kpiTrnUno
    objKPIView.kpiTrnIssueUno = this.kpiTrnIssueNo;
    objKPIView.issueDescription = this.issueComment;
    objKPIView.issueStatusUno = this.resettypeCode;
    objKPIView.userUno = this.login_UserID;
    objKPIView.tenantUno = this.tenantUno;
    
    this.spinner.show();
    this.restApi.updateKpiIssue(objKPIView)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          //Swal.fire('Error', 'Something went wrong', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong.');
        }
        else {
          this.toaster.show('success', 'Success', 'Issue Status Updated.');
          //Swal.fire({
          //  type: 'success',
          //  title: 'KPI Updated',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.loadSlaIssueList(2);
          //this.loadDashboard(2);

        }


        this.spinner.hide();

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
    return true;
  }
  onSubmitIssueDesc() {


    let objKPIView = new slaIssueList();
    objKPIView.kpiUno = 0;
    objKPIView.kpiTrnUno = this.kpiTrnUno;
    objKPIView.issueDescription = this.issueComment;

    objKPIView.userUno = this.login_UserID;
    objKPIView.tenantUno = this.tenantUno;
    
    this.spinner.show();
    this.restApi.updateKpiIssueDescription(objKPIView)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          // Swal.fire('Error', 'Something went wrong', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong.');
        }
        else {
          this.toaster.show('success', 'Success', 'Issue Updated');
          //Swal.fire({
          //  type: 'success',
          //  title: 'KPI Updated',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.loadSlaIssueList(2);
          //this.loadDashboard(2);
        }


        this.spinner.hide();

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
    return true;
  }

  // Get SlaIssueList list
  loadSlaIssueList(condition) {
    this.loadActionPlan();
    this.loadDashboard(2);
    
    this.spinner.show();
    let inpValue = new slaIssueList();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 4;// condition;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.slaUno = this.slaUno ? this.slaUno : 0;
    inpValue.kpiyear = this.yearUno ? this.yearUno : 0;
    inpValue.kpiquarter = this.quarterUno ? this.quarterUno : 0;
    inpValue.divisionUno = this.divisionUno ? this.divisionUno : 0;
    inpValue.frequencyUno = this.frequencyUno ? this.frequencyUno : 0;
    inpValue.half = this.currentHalf;
    inpValue.month = this.currentMonth;
    this.restApi.getSlaIssueList(inpValue)
      .subscribe(data => {
        
        //this.loadDashboard(2);
        this.slaIssuelist_data = data;
        const mockDataset = [];
        for (let i = 0; i < this.slaIssuelist_data.length; i++) {
          if (this.slaIssuelist_data[i].completion == "") {
            this.slaIssuelist_data[i].completion = 0
          }
          mockDataset[i] = {
            id: i + 1,
            kpiCode: this.slaIssuelist_data[i].kpiCode,
            kpiName: this.slaIssuelist_data[i].kpiName,
            periodDisplay: this.slaIssuelist_data[i].periodDisplay,
            issueDescription: this.slaIssuelist_data[i].issueDescription,
            issueStatus: this.slaIssuelist_data[i].issueStatus,
            kpiUno: this.slaIssuelist_data[i].kpiUno,
            kpiTrnIssueUno: this.slaIssuelist_data[i].kpiTrnIssueUno,
            bandColour: this.slaIssuelist_data[i].bandValue,
            kpiTrnUno: this.slaIssuelist_data[i].kpiTrnUno,//view
            completion: this.slaIssuelist_data[i].completion,
            division: this.slaIssuelist_data[i].divisionName,
            view: 'View',
            businessDivisionUno: this.slaIssuelist_data[i].businessDivisionUno,
            reportingDivisionUno: this.slaIssuelist_data[i].reportingDivisionUno
          };
        }
        this.dataset = mockDataset;
        this.dataSearch = mockDataset;
        if (mockDataset.length > 0) {
          this.setColnDefn();
        }
        this.loading = false;
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  drawertoggle() {
    
    this.isToggle = (this.isToggle) ? false : true;
  }

  // Choose city using select dropdown
  onchangeSLA(e) {
    
    //alert(e.itemData.slaUno);
    this.slaUno = (e && e.length > 0) ? e[0].value : 0;
    this.onSelectedTab();

  }
  onchangeYear(e) {
    
    this.yearUno = (e && e.length > 0) ? e[0].value : 0;
    this.onSelectedTab();
  }


  onchangeQuarter(e) {
    this.quarterUno = (e && e.length > 0) ? e[0].value : 0;
    this.onSelectedTab();
  }


  onchangeDivision(e) {
    this.divisionUno = (e && e.length > 0) ? e[0].value : 0;
    this.onSelectedTab();
  }


  onchangeFrequency(e) {
    
    this.frequencyUno = (e && e.length > 0 && e[0].value != 'All') ? e[0].value : 0;
    this.onSelectedTab();
  }


  onSelectedTab() {
    this.setFilterValue();
    this.loadSlaIssueList(2); //by filter
    
    //this.loadDashboard(2);
  }



  backClick() {
    this.router.navigate(['/sladashboard/report'], { queryParams: { yearsla: this.yearUno, quatersla: this.quarterUno, divisionsla: this.divisionUno } });

  }

  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }

  exportToExcelIssue() {
    var temp = this;
    setTimeout(function () {
      temp.issueGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }

  exportToExcelCmt() {
    var temp = this;
    setTimeout(function () {
      temp.cmtsGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }
  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.kpiCode && a.kpiCode.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.kpiName && a.kpiName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.periodDisplay && a.periodDisplay.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.issueDescription && a.issueDescription.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.bandValueText && a.bandValueText.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.issueStatus && a.issueStatus.toLowerCase().includes(this.searchText.toLowerCase())));
    }
    else
      this.dataset = this.dataSearch;
  }

  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', sortable: true,
        minWidth: 200,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiCode', 'kpiCode'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'kpiName', name: 'KPI', field: 'kpiName', sortable: true,
        //minWidth: 250,
        width: 200,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiName', 'kpiName'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'periodDisplay', name: 'Period', field: 'periodDisplay', sortable: true,
        width: 100,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'periodDisplay', 'periodDisplay'),
          model: Filters.multipleSelect,

        }
      },

      {
        id: 'issueDescription', name: 'Issue Description', field: 'issueDescription', sortable: true,
        //minWidth: 200,
        type: FieldType.string, filterable: true, width: 150,
        filter: {
          collection: this.uniqueArray(this.dataset, 'issueDescription', 'issueDescription'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'bandColour', name: 'Performance', field: 'bandColour',
        width: 100,
        sortable:
          true, type: FieldType.string, filterable: false, formatter: this.bandFormatter,
        filter: {
          collection: this.uniqueArray(this.dataset, 'bandColour', 'bandColour'),
          model: Filters.multipleSelect,
        },

      },
      {
        id: 'issueStatus', name: 'Status', field: 'issueStatus', sortable: true,
        width: 100,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'issueStatus', 'issueStatus'),
          model: Filters.multipleSelect,
        },

      },//completion
      
      {
        id: 'completion', name: 'Overall Progress', field: 'completion', sortable: true,
        //minWidth: 100,
        type: FieldType.string, filterable: true, width: 100,
        formatter: (row, cell, val, columnDef, data) => {
          let per = data.completion;

          return '<div class="progress" style="height: 15px; font-size:9px; text-indent: 2px; background-color:#999;"><div class="progress-bar bg-d-green text-left" role = "progressbar" style = "width:' + per + '%;" aria-valuenow="' + per + '" aria-aluemin="0" aria - valuemax="100" > ' + per + '% </div></div>';

        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'completion', 'completion'),
          model: Filters.multipleSelect,
        }
      },
      //{
      //  id: 'view', name: 'Action Plan', field: 'view', sortable: true, type: FieldType.string, filterable: true,
      //  formatter: this.actualFormatter,
      //  //formatter:this.formater() {
      //  //  '<a style="text-decoration:underline; cursor:pointer;" (click)="DataEntryKPI(data,\'dataentry\')">' + data.targetValueText + '</a>';

      //  //},
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'view', 'view'),
      //    model: Filters.multipleSelect,
      //  },
      //  onCellClick: (e: Event, args: OnEventArgs) => {
      //    
      //    let data = args.dataContext;

      //    // if ((data.dataOwnerExists == 1 || this.isAdmin) && data.bandColour == '' && data.dataOwnerActionBy == '' && (data.isNANRNT == '' || data.isNANRNT == null))
      //    this.navigateToAction(data);


      //  },

      //},

      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue',
        maxWidth: 75,
        //width: 50,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'view', titleKey: 'view', positionOrder: 62, title: 'Action Plan',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                let rtnValue = this.checkKPIDivision(data);
                if (this.isAdmin || rtnValue) {
                  return true;
                }
                else false;

              },
              iconCssClass: 'fa fa-list', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                var data = args.dataContext;
                this.setFilterValue();
                this.router.navigate(['dashboard-actionplandetail'], { queryParams: { kpiuno: data.kpiTrnUno } })
                //, { queryParams: { yearsla: this.yearUno, quatersla: this.quarterUno, divisionsla: this.divisionUno } });
              }
            },
            {
              command: 'Map Action Plan', titleKey: 'Map Action Plan', positionOrder: 63, title: 'Map Action Plan',
              iconCssClass: 'fa fa-link ', cssClass: 'blue', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                let rtnValue = this.checkKPIDivision(data);
                if (this.isAdmin || rtnValue) {
                  return true;
                }
                else false;

              },
              action: (e, args) => {
                var rdata = args.dataContext;
                //this.pageAction = "Map"
                //this.objActionPlan = this.data.filter((items: any) => items.actionPlanID == rdata.id)[0];
                //this.objActionPlan.kpiUno = (this.objActionPlan.kpiUno) ? this.utilityService.CommaSeperatorToArray(this.objActionPlan.kpiUno.toString()) : [];
                //this.objActionPlan.startDate = formatDate(this.objActionPlan.startDateFormat, 'yyyy-MM-dd', 'en-US');
                //this.objActionPlan.endDate = formatDate(this.objActionPlan.endDateFormat, 'yyyy-MM-dd', 'en-US');
                //this.objActionPlan.condition = 3
                this.actionKpiUno = rdata.kpiTrnUno;
                this.modalRef = this.modalService.show(
                  this.mapActiontemplate,
                  Object.assign({}, {
                    class: 'gray modal-medium',
                    backdrop: true,
                    keyboard: true,
                    focus: true,
                    show: false,
                    ignoreBackdropClick: true,
                    animated: true
                  })
                );
                //, { queryParams: { yearsla: this.yearUno, quatersla: this.quarterUno, divisionsla: this.divisionUno } });
              }
            },

            {
              command: 'Resolve-row', titleKey: 'Resolve_ROW', positionOrder: 64, title: 'Resolve Issue',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                let rtnValue = this.checkKPIDivision(data);
                if (this.isAdmin || rtnValue) {
                  if ((data.issueStatus != 'Resolved' && data.issueStatus != 'Closed' && data.issueStatus != 'Cancelled' && this.permision_resolve))
                    return true;
                  else false;
                }
                else false;
                
              },
              iconCssClass: 'fa fa-circle-o-notch fa-lg ', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                let data = args.dataContext;
                this.showIssueDialog(data, data.issueDescription, 'updatestatus')
              }
            },


            {
              command: 'Update-row', titleKey: 'Update_ROW', positionOrder: 65, title: 'Issue Update',
              iconCssClass: 'fa fa-edit fa-lg ', cssClass: 'blue', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                let rtnValue = this.checkKPIDivision(data);
                if (this.isAdmin || rtnValue) {
                  if (data.issueStatus != 'Resolved' && data.issueStatus != 'Closed' && data.issueStatus != 'Cancelled' && this.permision_issueUpdate)
                    return true;
                  else false;
                }
                else false;
              },
              action: (e, args) => {
                let data = args.dataContext;
                this.showIssueDialog(data, data.issueDescription, 'updatedescription')
              }
            },

            {
              command: 'Log-row', titleKey: 'Log_ROW', positionOrder: 66, title: 'Issue Log',
              iconCssClass: 'fa fa-history fa-lg orange-text  Blink ', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                let rtnValue = this.checkKPIDivision(data);
                if (this.isAdmin || rtnValue) {
                  return true;
                }
                else false;

              },
              action: (e, args) => {
                let data = args.dataContext;
                this.showIssueCommentDialog(data)
              },
            },


            {
              command: 'Info-row', titleKey: 'Info_ROW', positionOrder: 67, title: 'KPI Info',
              iconCssClass: 'fa fa-info-circle fa-lg ', cssClass: 'red', textCssClass: 'bold',

              action: (e, args) => {
                let data = args.dataContext;
                this.viewKPIHistoryAll(data.kpiUno, data.kpiName);
              }
            },
            
          ],
        }
      }
    ]


  }

  checkKPIDivision(data: any) {
    if (this.isInternalAudit) {
      return false;
    }

    //New Condition check
    if (data.businessDivisionUno != undefined && data.reportingDivisionUno != undefined && data.businessDivisionUno != null && data.reportingDivisionUno != null) {
      if ((data.businessDivisionUno.toString() == this.user.divisionUno.toString()))
      //|| (data.reportingDivisionUno.toString() == this.user.divisionUno.toString())
      {
        return true;
      }
    }
    
    return false;
  }
  navigateToAction(data) {
    
    let rtnValue = this.checkKPIDivision(data);
    if (this.isAdmin || rtnValue) {
      this.setFilterValue();
      this.router.navigate(['dashboard-actionplandetail'], { queryParams: { kpiuno: data.kpiTrnUno } })
      //{ queryParams: { yearsla: this.yearUno, quatersla: this.quarterUno, divisionsla: this.divisionUno } });
    }
  }
  actualFormatter: Formatter = (row, cell, value, columnDef, data) => {
    return '<a style="text-decoration:underline; cursor:pointer;" (click)="navigateToAction(data)">' + data.view + '</a>';

    //if (data.bandColour != '' && data.dataOwnerActionBy != '' && data.slaRuleUno != 4)
    //  return data.targetValue;
    //if ((data.bandColour != '' && data.dataOwnerActionBy != '' && data.slaRuleUno == 4))
    //  return data.bandColour == 'Green' ? 'Pass' : 'Fail';
    //if (data.bandColour == '' && data.dataOwnerActionBy != '' && data.dataOwnerActionBy != null && (data.isNANRNT != null && data.isNANRNT != ''))
    //  return data.isNANRNT;
    //if ((data.dataOwnerExists == 1 || this.isAdmin) && data.bandColour == '' && data.dataOwnerActionBy == '' && (data.isNANRNT == '' || data.isNANRNT == null)) {
    //  return '<a matTooltipClass="my-custom-tooltip-avg" title="Data Entry"  class="bcopy-btn" style="cursor:pointer !important;">-</a>'
    //}
    //if (data.bandColour == '' && data.dataOwnerActionBy != '' && data.isNANRNT != '') {
    //  return '<a  style="text-decoration:underline; cursor:pointer;" >' + data.isNANRNT + '</a>';
    //}
    ////if (data.view == 'view') {
    //  return '<a  style="text-decoration:underline; cursor:pointer;" >' + 'view' + '</a>';

    //}


  };

  bandFormatter: Formatter = (row, cell, value, columnDef, data) => {
    
    //if (data.slaRuleUno != 1 && data.slaRuleUno != 2 && data.bandColour == '' && (data.isNANRNT != null && data.isNANRNT != ''))
    //  return `<div class="bg-grey-progress" > <span class="bluedark-bar"></span></div>`;
    //if (data.bandColour == '' && (data.slaRuleUno == 1 || data.slaRuleUno == 2) && (data.isNANRNT == 'NA' || data.isNANRNT == 'ND' || data.isNANRNT == 'NR'))
    //  return `<div class="bg-grey-progress" > <span class="bluedark-bar"></span></div>`;
    if (data.bandColour == 'Red')
      return `<div class="bg-grey-progress" > <span class="red-bar"></span></div>`;
    if (data.bandColour == 'Orange')
      return `<div class="bg-grey-progress" > <span class="orange-bar"></span></div>`;
    if (data.bandColour == 'Yellow')
      return `<div class="bg-grey-progress" > <span class="yellow-bar"></span></div>`;
    if (data.bandColour == 'Light Green')
      return `<div class="bg-grey-progress" > <span class="light-green-bar"></span></div>`;
    if (data.bandColour == 'Green')
      return `<div class="bg-grey-progress" > <span class="green-bar"></span></div>`;

  };

  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    // angularGrid
    this.userService.angularGrid = angularGrid;
  }

  cmtsGridReady(angularGrid: AngularGridInstance) {
    this.cmtsGrid = angularGrid;
  }


  setCommentDefn() {
    this.columnCommentDefinitions = [
      { id: 'comment', name: 'Comment', field: 'comment', sortable: true, minWidth: 200 },
      { id: 'postedBy', name: 'Action By', field: 'postedBy', sortable: true, width: 10 },
      { id: 'postedDate', name: 'Action On', field: 'postedDate', sortable: true, width: 20 },


    ];
  }

  // Get SlaIssueList list
  loadDashboard(condition) {
    
    this.spinner.show();
    let inpValue = new slaIssueList();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = condition;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.slaUno = this.slaUno ? this.slaUno : 0;
    inpValue.currentYear = this.yearUno ? this.yearUno : 0;
    inpValue.currentQuarter = this.quarterUno ? this.quarterUno : 0;
    inpValue.divisionUno = this.divisionUno ? this.divisionUno : 0;
    inpValue.frequencyUno = this.frequencyUno ? this.frequencyUno : 0;
    inpValue.currentHalf = this.currentHalf;
    inpValue.currentMonth = this.currentMonth;
    this.restApi.getSlaIssueDashboard(inpValue)
      .subscribe((data:any) => {
        if (data[0].listDivisionIssue.length > 0) {
          this.issueReported = data[0].listDivisionIssue[0].issueReported;
          this.issueResolved = data[0].listDivisionIssue[0].issueResolved;
          this.devisionCode = data[0].listDivisionIssue[0].devisionCode;
          this.Piedataset = data[0].listDivisionIssue;

        }
        else {
          this.issueReported =null//data[0].listDivisionIssue[0].issueReported;
          this.issueResolved = null//data[0].listDivisionIssue[0].issueResolved;
          this.devisionCode = null
          this.Piedataset = [];
        }
        if (data[0].listWellPerformedKPI.length > 0) {
          this.issueArraised = data[0].listWellPerformedKPI[0].issueArraised;
          this.wellPerformed = data[0].listWellPerformedKPI[0].wellPerformed;
        }
        else {
          this.issueArraised = 0//data[0].listWellPerformedKPI[0].issueArraised;
          this.wellPerformed = 0
        }
        if (data[0].listIssueType.length > 0) {
          this.pendingIssues = data[0].listIssueType[0].pendingIssue;
          this.inProgressIssues = data[0].listIssueType[0].inprogress;
          this.ResolvedIssues = data[0].listIssueType[0].resolved;
        }
        else {
          this.pendingIssues = 0//data[0].listIssueType[0].pendingIssue;
          this.inProgressIssues = 0// data[0].listIssueType[0].inprogress;
          this.ResolvedIssues = 0
        }
        //if (data.length > 0) {
        //  this.issueArraised = data[0].listWellPerformedKPI[0].issueArraised;
        //  this.wellPerformed = data[0].listWellPerformedKPI[0].wellPerformed;
        //  this.pendingIssues = data[0].listIssueType[0].pendingIssue;
        //  this.inProgressIssues = data[0].listIssueType[0].inprogress;
        //  this.ResolvedIssues = data[0].listIssueType[0].resolved;
        //  this.underPerforming = data[0].listDivisionIssue[0].underPerforming;
        //  this.issueReported = data[0].listDivisionIssue[0].issueReported;
        //  this.issueResolved = data[0].listDivisionIssue[0].issueResolved;
        //  this.devisionCode = data[0].listDivisionIssue[0].devisionCode;
        //  this.Piedataset = data[0].listDivisionIssue;
        //}
        
       

        this.drawWellPerformedKPIPie();
        this.loading = false;
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  drawWellPerformedKPIPie() {
   
    var pecentage = Math.round(((this.wellPerformed / this.issueArraised) * 100))
    //var pecentage = Math.round(((2/8) * 100))
    if (!pecentage) {
      pecentage=0
    }
    
    //this.chartOption05 = {

    //  tooltip: {
    //    trigger: 'item'
    //  },
    //  color: ['#5abeec'],
    //  //color: ['#5abeec'],
    //  legend: {
    //    top: '5%',
    //    show: false,
    //    left: 'center'
    //  },
    //  series: [
    //    {
    //      name: '',
    //      type: 'pie',
    //      radius: ['55%', '70%'],
    //      //radius: ['100%'],
    //      avoidLabelOverlap: false,
    //      // label: {
    //      //   show: false,
    //      //   position: 'center'
    //      // },
    //      label: {

    //        color: '#000',
    //        fontSize: '30',
    //        silent: true,
    //        position: 'center',
    //        formatter: () => {
    //        //   return "96%" // Use sum variable here
    //        return (pecentage.toString() + '%');
    //        },
    //      },
    //      // emphasis: {
    //      //   label: {
    //      //     show: false,
    //      //     fontSize: '40',
    //      //     fontWeight: 'bold'
    //      //   }
    //      // },
    //      labelLine: {
    //        show: false
    //      },
    //      data: [
    //        { value: this.issueArraised, name: 'Issue Reported' },
    //        { value: this.wellPerformed, name: 'Well Performed' },
           

    //        // { value: 580, name: 'Reported' },
    //        // { value: 484, name: 'Performed' },
    //        // { value: 300, name: 'Video Ads' }
    //      ]
    //      //data: data,
    //    }
    //  ]
    //};

    this.chartOption05 = {

      //tooltip: {
      //  trigger: 'item'
      //},
       color: ['#68b097', '#d0e6de'],
      legend: {
        top: '5%',
        show: false,
        left: 'center'
      },
      series: [
        {
          name: 'Access From',
          type: 'pie',
          radius: ['55%', '70%'],
          avoidLabelOverlap: false,
          // label: {
          //   show: false,
          //   position: 'center'
          // },
          label: {

            color: '#000',
            fontSize: '30',
            silent: true,
            position: 'center',
            formatter: () => {
              // return "96%" // Use sum variable here
              return (pecentage.toString() + '%');
            },
          },
          // emphasis: {
          //   label: {
          //     show: false,
          //     fontSize: '40',
          //     fontWeight: 'bold'
          //   }
          // },
          labelLine: {
            show: false
          },
          data: [
            { value: pecentage },
            { value: (100 - pecentage) },
          ]
          //data: data,
        }
      ]
    };


    var issueResolution = Math.round((this.ResolvedIssues / (this.pendingIssues + this.inProgressIssues + this.ResolvedIssues)) * 100)
    if (!issueResolution) {
      issueResolution = 0
    }
    this.ResolutionString = issueResolution.toString() + '%'

    
    this.chartOption06 = {
      title: {
       // text: issueResolution.toString() + '%',
        textStyle: {
          fontSize: '48',
          color: '#6c757d',
          //lineHeight: 30,
          //height: 200,

        },
        padding: [0, 0],
        textAlign: 'left',
        //itemGap: 20,

       // subtext: 'Issues Status',
      },

      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {
        show: false,
      },
      barWidth: "50%",
      //barCategoryGap: "20%",
      barGap: "75%",
      grid: {
        // left: '3%',
        // right: '4%',
        bottom: '3%',
        containLabel: true,
        left: "13px", right: "0px"
      },
      xAxis: {
        type: 'value',
        //boundaryGap: [0, 0.01]
        axisLine: {
          show: false, // Hide full Line
        },
        axisTick: {
          show: false, // Hide Ticks,
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          show: false,

        }

      },


      yAxis: {
        type: 'category',
        data: ['In Progress', 'Pending', 'Resolved'],
        axisLine: {
          show: false, // Hide full Line
        },
        axisTick: {
          show: false, // Hide Ticks,
        },
        axisLabel: {
          //show: false,
          //margin: 10,
          //width: "50",
          //overflow: 'truncate',
        }

      },
      series: [
        {
          label: {
            show: true,
            position: 'insideTop',
            color:'#fff'
          },

          data: [
            {
              value: this.inProgressIssues,//8
              itemStyle: {
                color: '#68b097',

              }
            },
            {
              value: this.pendingIssues, //4
              itemStyle: {
                color: '#81cfd9'
              }
            },
            {
              value: this.ResolvedIssues,//3
              itemStyle: {
                color: '#c9ee91'
              },

            },

          ],
          type: 'bar',
          // barCategoryGap: 0,
          // barGap: '50%',
        }
      ]



    };
    //this.chartOption06 = {
    //  title: {
    //    text: '98%'
    //  },

    //  tooltip: {
    //    trigger: 'axis',
    //    axisPointer: {
    //      type: 'shadow'
    //    }
    //  },
    //  legend: {
    //    show: false,
    //  },
    //  barWidth: "40%",
    //  // barCategoryGap: "10%",
    //  // barGap: "10%",
    //  grid: {
    //    // left: '3%',
    //    // right: '4%',
    //    // bottom: '5%',
    //    containLabel: true
    //  },
    //  xAxis: {
    //    type: 'value',
    //    //boundaryGap: [0, 0.01]
    //    axisLine: {
    //      show: false, // Hide full Line
    //    },
    //    axisTick: {
    //      show: false, // Hide Ticks,
    //    },
    //    splitLine: {
    //      show: false
    //    },
    //    axisLabel: {
    //      show: false
    //    }

    //  },


    //  yAxis: {
    //    type: 'category',
    //    data: ['In Progress', 'Pending', 'Resolved'],
    //    axisLine: {
    //      show: false, // Hide full Line
    //    },
    //    axisTick: {
    //      show: false, // Hide Ticks,
    //    },
    //  },
    //  series: [
    //    {
    //      label: {
    //        show: true,
    //        position: 'right'
    //      },

    //      data: [
    //        {
    //          value: this.pendingIssues,
    //          itemStyle: {
    //            color: '#f8cd56',

    //          }
    //        },
    //        {
    //          value: this.inProgressIssues,
    //          itemStyle: {
    //            color: '#e1735a'
    //          }
    //        },
    //        {
    //          value:this.ResolvedIssues ,
    //          itemStyle: {
    //            color: '#357b87'
    //          },

    //        },

    //      ],
    //      type: 'bar',
    //      //type:'horizontalBar',
    //      // barCategoryGap: 0,
    //      // barGap: '50%',
    //    }
    //  ]



    //};
    var tempArray_XAxis = [];
    var tempArray_underPerforming = [];
    var tempArray_issueReported = [];
    var tempArray_issueResolved = [];
    var pieDataTemp = []
    
    for (var i = 0; i < this.Piedataset.length; i++) {
      let devision = this.Piedataset[i].divisionCode;
      let underPerforming = this.Piedataset[i].underPerforming;
      let issueReported = this.Piedataset[i].issueReported;
      let issueResolved = this.Piedataset[i].issueResolved //divisionCode
      pieDataTemp.push(this.Piedataset[i]);
      pieDataTemp[i]["Under-performing KPI's"] = this.Piedataset[i].underPerforming;
      pieDataTemp[i]["Issues reported"] = this.Piedataset[i].issueReported;
      pieDataTemp[i]["Issues resolved"] = this.Piedataset[i].issueResolved
      pieDataTemp[i]["divisionCode"] = this.Piedataset[i].divisionCode
      tempArray_XAxis.push(devision);
      tempArray_underPerforming.push(underPerforming);
      tempArray_issueReported.push(issueReported);
      tempArray_issueResolved.push(issueResolved);
      //  tempArray.push([option_data[i].year, parseInt(option_data[i].actualValue), parseInt(option_data[i].targetValue)]);
    }

    this.chartOption07 = {
      legend: {
        right: '5%',
        show: false,

      },
      tooltip: {},
      //color: ['#68b097', '#81cfd9', '#c9ee91'],
      //color: ['#F0A067', '#D2D2D9', '#68b097'],
      color: ['#239cce', '#e7e7e7', '#20afbe'],
      height: 110,
      dataset: {
        //dimensions: ['product', '2015', '2016', '2017'],
        //dimensions: ['divisionCode', 'underPerforming', 'issueReported', 'issueResolved'],
        dimensions: ['divisionCode', "Under-performing KPI's", 'Issues reported', 'Issues resolved'],
        
        //dimensions: ['tempArray_XAxis', 'tempArray_underPerforming', 'tempArray_issueReported', 'tempArray_issueResolved'],
        source: pieDataTemp // this.Piedataset // [

        //{ product: 'tempArray_XAxis', underPerforming: 'tempArray_underPerforming', issueReported: 'tempArray_issueReported', issueResolved: 'tempArray_issueResolved' },
        //{ product: 'DEWA', 2015: 43, 2016: 85, 2017: 93 },
        //{ product: 'GD', 2015: 83, 2016: 73, 2017: 55 },
        //{ product: 'W&C', 2015: 86, 2016: 65, 2017: 82 },
        //{ product: 'Billing', 2015: 72, 2016: 53, 2017: 39 },
        //{ product: 'FD', 2015: 72, 2016: 53, 2017: 39 },
        //{ product: 'DP', 2015: 72, 2016: 53, 2017: 39 },
        //{ product: 'S&GC', 2015: 72, 2016: 53, 2017: 39 },
        //{ product: 'LA', 2015: 72, 2016: 53, 2017: 39 },
        //{ product: 'BS&HR', 2015: 72, 2016: 53, 2017: 39 },

        // ]
      },
      xAxis: {
        type: 'category',
        name: "",//No of KPI's
        nameLocation: 'middle',
        nameGap: 50,
        show: true
      },
      yAxis: {
        axisLabel: {
          formatter: '{value}'
        },
        name: '',//Division
        nameLocation: 'middle',
        nameGap: 50,
        show: true
      },
      // Declare several bar series, each will be mapped
      // to a column of dataset.source by default.
      series: [{
        
        type: 'bar', barGap: 0.3, barCategoryGap: '50%', label: {
          show: true,
          position: 'top'
        },
      }, {
          type: 'bar', barGap: 0.3, barCategoryGap: '50%', label: {
          show: true,
          position: 'top'
          
        },
      }, {
          type: 'bar', barGap: 0.3, barCategoryGap: '50%', label: {
          show: true,
          position: 'top'
        },
      }]
    };


  }

  onDbClicked(e, es) {
    
    let objitem = this.angularGrid.gridService.getDataItemByRowIndex(es.row)
    this.setFilterValue();
    if (objitem != null && objitem != undefined) {
      //this.objActionPlan = this.data.filter((items: any) => items.actionPlanID == objitem.id)[0];
      let rtnValue = this.checkKPIDivision(objitem);
      if (this.isAdmin || rtnValue) {
        this.router.navigate(['dashboard-actionplandetail'], { queryParams: { kpiuno: objitem.kpiTrnUno } })
      }
    }
  }

  setFilterValue() {
    
    let strFilter: any = "";
    strFilter = '{"slaUno"' + ':' + '"' + this.slaUno + '"' + ',' + '"yearUno"' + ':' + '"' + this.yearUno + '"' + ',' + '"quarterUno"' + ':' + '"' + this.quarterUno + '"' + ',' + '"divisionUno"' + ':' + '"' + this.divisionUno + '"' + ',' + '"frequencyUno"' + ':' + '"' + this.frequencyUno + '"' + '}'
    if (localStorage.getItem('strFilter')) {
      localStorage.removeItem('strFilter')
    }
    localStorage.setItem('strFilter', strFilter);
  }

  // Get ActionPlan list
  loadActionPlan() {
    this.spinner.show();
    let inpValue = new actionPlan();
    inpValue.languageUno = 1033;
    //inpValue.itemUno = 0;
    inpValue.condition = 2;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.yearUno = this.yearUno ? this.yearUno : 0;
    inpValue.quarterUno = this.quarterUno ? this.quarterUno : 0;
    this.Actiondata = [];

    this.restApi.getActionPlan(inpValue)
      .subscribe(data => {
        
        
        this.Actiondata = uniqBy(data, 'actionPlanCode');

        //if (!this.isAdmin) {
        //  this.Actiondata = this.Actiondata.filter(a =>
        //    (a.divisionUno.toString() == this.user.divisionUno.toString()));

        //}
        
        

        this.spinner.hide()

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  AddEditSLA(condition: any) {
   // this.slaIssuelist_data
    let selectedDivisionData: any;
    let divisionUno: any;
    let ActionDivision: any;
    let selectedActionData: any;
    let actionCode: any;
    selectedDivisionData = this.slaIssuelist_data.filter(a => a.kpiTrnUno.toString() == this.actionKpiUno.toString());
    selectedActionData = this.Actiondata.filter(a => a.actionPlanID.toString() == this.actionPlanID.toString());
    actionCode = selectedActionData[0].actionPlanCode;
    ActionDivision = selectedActionData[0].divisionUno;
    divisionUno = selectedDivisionData[0].divisionUno;
    //if (divisionUno.toString() != ActionDivision.toString()) {
    //  this.toaster.show('error', 'Error', 'Please select Action Plan from same Division');
    //  return false;
    //}
    this.objActionPlan.actionPlanCode = actionCode;
    this.objActionPlan.actionType = "Map";
    this.objActionPlan.actionPlanID = this.actionPlanID
    this.objActionPlan.userUno = this.login_UserID;
    this.objActionPlan.tenantUno = this.tenantUno;
    this.objActionPlan.kpiUno = this.actionKpiUno;
    let kpi = this.objActionPlan.kpiUno;
    this.objActionPlan.condition = condition;
    this.spinner.show();

    this.objActionPlan.yearUno = this.yearUno ? this.yearUno : 0;
    this.objActionPlan.quarterUno = this.quarterUno ? this.quarterUno : 0;

    this.restApi.addEditActionPlan(this.objActionPlan)
      .subscribe(data => {
        if (data == null && data != undefined && data != '' && (data.toString().indexOf('MSID_') <= 0)) {
          // Swal.fire('Error', 'Something went wrong', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong.');
        }
        else {
          if (data == '999') {
            //this.toaster.show('error', 'Error', 'KPI already mapped to another Plan, please try other kpi');
            Swal.fire({
              title: 'Confirmation',
              text: 'KPI already mapped to another Plan.Do you want to continue?',
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes',
              cancelButtonText: 'Cancel'
            }).then((result) => {
              if (result.value) {
                this.objActionPlan.condition = 6;
                this.objActionPlan.kpiUno = kpi;
                this.AddEditSLA(6)
              } else if (result.dismiss === Swal.DismissReason.cancel) {

                //this.loadActionPlan();
              }
            })
          } else {
            this.toaster.show('success', 'Success', 'Action Plan Mapped.');
            
            
            this.modalRef.hide();
            //this.SLAno = (this.pageAction == "add") ? data.toString() : this.SLAno;
            //this.uploadFiles();
            this.loadActionPlan();
            this.loadSlaIssueList(4);
          }
        }
        //setTimeout(() => { this.spinner.hide(); this.loadActionPlan(); }, 1100);
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
    //}
  }

  onSubmitAction() {
    if (this.actionPlanID == null) {
      this.isActionPlan = true;
      return false;
    }
    else {
      this.isActionPlan = false;
      this.AddEditSLA(4);
    }
      
  }
}


